import { render } from "./LoaderComp.vue?vue&type=template&id=962f1ef6&scoped=true"
import script from "./LoaderComp.vue?vue&type=script&lang=js"
export * from "./LoaderComp.vue?vue&type=script&lang=js"

import "./LoaderComp.vue?vue&type=style&index=0&id=962f1ef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-962f1ef6"]])

export default __exports__